import application_settings from '../applicationSettings';
import Event from './Event';

class SubmitReview extends Event {
    eventName = 'oms_submitReviewEvent';

    constructor() {
        super();
        this.add();
    }

    eventFunction(data) {
        let clientId = data.client_id;
        let productId = data.productId;
        let orderId = data.orderId;
        let formData = data.formData;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (orderId && productId && formData?.rating) {
            // request data
            data.endPoint = application_settings.endPoints.addReview;
            data.method = 'POST';
            data.canUsePublicAuth = false;
            data.data = {
                product_id: productId,
                order_id: orderId,
                rate: formData.rating,
                comment: formData.comment,
                images: formData.uploadedFiles,
                is_anonymous_review: formData.isAnonymousReview
            };
            // send request
            this.sendRequest(data, function (response) {
              if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
              }
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "orderId & productId & rating is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }


}

export default SubmitReview;